import * as React from 'react';

import {SectionLabel} from 'shells/typography/section-label';

import {PeepLastContactedTimes} from './peep-last-contacted-times';
import {PeepRecurringTaskControls} from './peep-recurring-task-controls';

import styles from './peep-recurring-tasks.module.css';

type Props = {
    peepApiId: string;
    model: any;
};

export class PeepRecurringTasks extends React.Component<Props> {
    componentDidMount() {
        this.props.model.on('change', this.forceRerender);
    }

    componentWillUnmount() {
        this.props.model.off('change', this.forceRerender);
    }

    render() {
        return (
            <div className={styles['peep-recurring-tasks']}>
                <SectionLabel>Keep in touch</SectionLabel>
                <PeepLastContactedTimes
                    apiId={this.props.peepApiId}
                    backboneModel={this.props.model}
                />
                <PeepRecurringTaskControls model={this.props.model} />
            </div>
        );
    }

    forceRerender = () => {
        this.forceUpdate();
    };
}
